export default __webpack_public_path__ + "static/O0041-6f362aa1d7c2f305b9c75724c0ca425a.png";